import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
const VisitorAppointmentFrontDeskList = React.lazy(() => { return import('./components/VisitorAppointmentFrontDeskList'); });
const { Cell } = ResponsiveGrid;

const VisitorAppointmentFrontDesk = () => (
  // <ResponsiveGrid gap={20}>
  //   <Cell colSpan={12}>
  //     <PageHeader
  //       title="訪客預約前台"
  //       // description="訪客列表"
  //       breadcrumbs={[
  //         {
  //           name: '訪客管理',
  //         },
  //         {
  //           name: '訪客預約前台',
  //         },
  //       ]}
  //     />
  //   </Cell>

  //   <Cell colSpan={12}>
  //     <VisitorAppointmentFrontDeskList />
  //   </Cell>
  // </ResponsiveGrid>

  <React.Suspense fallback={<div style={{fontSize:"36px",color: "#1f2d49"}}>Loading...</div>} >
  <VisitorAppointmentFrontDeskList />
  </React.Suspense>

);

export default VisitorAppointmentFrontDesk;
